import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type {
    GetAdminBusinessInsightsGrowthResponse,
    UseGetAdminBusinessInsightsGrowthParams,
    UseGetAdminBusinessInsightsGrowthResult,
} from './types';

const useGetAdminBusinessInsightsGrowth = ({
    enabled,
}: UseGetAdminBusinessInsightsGrowthParams): UseGetAdminBusinessInsightsGrowthResult => {
    const { data, isLoading, error, refetch } =
        useHttpQuery<GetAdminBusinessInsightsGrowthResponse>({
            pathname: '/admin/business-insights/growth',
            method: 'GET',
            key: ['admin-business-insights-growth'],
            queryOptions: {
                enabled,
            },
        });

    return {
        growth: data?.data ?? null,
        isLoadingGrowth: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useGetAdminBusinessInsightsGrowth;
